var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"header-title":` `,"header_logo":true,"header_side":true}},[_c('button',{staticClass:"h_search_btn",attrs:{"slot":"headerBtns"},on:{"click":function($event){return _vm.movePage('/search')}},slot:"headerBtns"})]),_c('google-register-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }